import React from 'react';
import Helmet from 'react-helmet';
import SEO from '../../../components/SEO';
import Layout from '../../../layouts/index';
import HtmlParser from 'html-react-parser';
import { DemoFormLong } from '../../../components/DemoFormLong.jsx';
import CaseStudyHero from '../../../components/CaseStudyHero';
import UserTestimonyCardNoLogo from '../../../components/cards/UserTestimonyCardNoLogo';
import JoinHappyCustomers from '../../../components/JoinHappyCustomers';
import '../../../scss/pages/_customer-story-page.scss';
import { PATHS } from '../../../utils/urls';

const Resources = (props) => {
	const location = props.location;

	return (
		<Layout  bodyClass="customer-story-page invision-story-page" ontouchstart>
			<SEO title="Case Study: InVision | ChartHop | People Analytics, Visualized" />
			<Helmet>
				<meta
					name="description"
					content="As a fully distributed company, InVision needed “self-service” organizational information system. ChartHop made that possible, without the manual work."
				/>
				<meta property="og:url" content={`https://www.charthop.com${location.pathname}`} />
				<meta property="og:title" content="Case Study: InVision | ChartHop | People Analytics, Visualized" />
				<meta property="og:description" content="As a fully distributed company, InVision needed “self-service” organizational information system. ChartHop made that possible, without the manual work." />
				<meta property="og:image" content={`https://www.charthop.com/home/charthop-facebook.png`} />
				<meta property="og:type" content="website" />
				<meta property="og:locale" content="en_US" />
        		<meta property="og:site_name" content="ChartHop" />
				{/* Twitter Card tags */}
				<meta name="twitter:title" content="Case Study: InVision | ChartHop | People Analytics, Visualized" />
				<meta name="twitter:description" content="As a fully distributed company, InVision needed “self-service” organizational information system. ChartHop made that possible, without the manual work." />
				<meta name="twitter:image" content={`https://www.charthop.com/home/charthop-twitter.jpg`} />
				<meta name="twitter:card" content="summary_large_image" />
				<meta name="twitter:site" content="@charthop" />
                <meta name="twitter:creator" content="@charthop" />
			</Helmet>

            <CaseStudyHero
                name="InVision"
                title="Managing a global, fully distributed, workforce"
                logo="/customers/invision/invision-logo.svg"
                titlePosition="top"
				background="/customers/customer-stories/background-hero.png"
				pdfUrl="/customers/invision-case-study.pdf"
				caseStudySource="customers-invision-PDF-case-study-header"
            />

			{/* USER TESTIMONY SECTION*/}
			<section className="text-left flex-centeredColumn sectionSpacing backgroundGradientContainer-Reverse" id="Testimony">
				<div className="contentBlock d-flex justify-content-between flex-wrap gridContainer"> 
				<UserTestimonyCardNoLogo
						testimony={HtmlParser('<p>"ChartHop has been an incredible game changer to us at InVision. I’m literally in it several times a week.</p><p>It’s been a LONG time since a SaaS product has changed the way I operate the business with as much impact."</p>')}
						name="Clark Valberg"
						position="CEO @ InVision"
						image="/customers/invision/ClarkValberg_Invision.jpeg"
						cardColor="#FFFFFF"
					/>
				</div>
			</section>			

			{/*Before ChartHop Section */}
			<section className="before-charthop-section sectionSpacing">
				<div className="container pt-3 pb-5">					
					<div  className="row align-items-center pt-3 pt-mt-4 pt-lg-5">
						{/*Before Charthop COl */}
						<div className="col-md-7 col-lg-6">
							<div className="mr-md-2">
								<h2>Reimagining workplace culture on a global scale</h2>
								<p>
								For every competitive advantage offered by a fully distributed company, there are just as many operational obstacles to be overcome.
								</p><p> 
								“When you’re supporting a global workforce, the last thing you want to be is a bottleneck for information or to feel friction when trying to get things done,”
								</p><p> 
								As a global distributed team, one of their biggest challenges was how to actually design and build a “self-service” information model. Keeping track of how InVision was growing as an organization and visualizing those relationships was becoming increasingly complex.
								</p><p> 
								The People Ops team spent around 15 hours every month––roughly four hours every week––just keeping InVision’s org chart up-to-date. Automating this org-chart alone would <b>save InVision $60,000 annually––the equivalent of a full-time junior-level hire––</b> and would free up the team to solve more complex problems that couldn’t be easily automated.
								</p><p>
								That’s when the team set out to find a solution that could help them solve these challenges.
								</p>
							</div>
						</div>

						{/*About Mongo can COl */}
						<div className="containerAbout col-md-5 col-lg-6" >	          
							<div className="flex-centeredColumn contentBlock background-about">
								<h4 className="h4-big"><strong>About</strong></h4>
								<img src={'/customers/invision/invision-logo-white.svg'} alt="Even Financial" style={{margin: `auto`, maxWidth: 200}}/>
								<h4 className="h4-big"><strong>-</strong></h4>
								<h4><strong>Founded:</strong> 2011</h4>
								<h4><strong>Industry:</strong> Technology</h4>
								<h4><strong>Type:</strong> Private</h4>
								<h4><strong>Number of Employees:</strong> 600+</h4>
								<h4 className="h4-padding-bottom"><strong>Fully Distributed</strong></h4>
							</div><br/><br/>

							<h4 className="text-center"><strong>InVision was wasting:</strong></h4>
							<br/>
							<div className="flex-centeredColumn contentBlock">
								<div className="flex-platform svg-info-beforeChartHop">
									<div className="svg-info-card-3col2">
										<img src={'/product/org-chart/time2.svg '} alt="Visualize" />
										<p>Time</p>
									</div>
									<div className="svg-info-card-3col2">
										<img src={'/product/org-chart/money.svg'} alt="Put a face to the name" />
										<p>Money</p>
									</div>
									<div className="svg-info-card-3col2 ">
										<img src={'/product/org-chart/productivity2.svg'} alt="Time Saving" />
										<p>Productivity</p>
									</div>        
								</div>
							</div>
						</div>
					</div>
				</div>
			</section>

			{/* USER TESTIMONY SECTION*/}
			<section className="text-left flex-centeredColumn sectionSpacing backgroundGradientContainer" id="Testimony">
				<div className="contentBlock d-flex justify-content-between flex-wrap gridContainer"> 
					<UserTestimonyCardNoLogo
						testimony={<p>
							 "ChartHop wasn't an org chart company, but had the best org chart on the market. We were looking for an org chart and ended up getting a robust business intelligence foundation for talent management headcount planning, compensation planning and reporting."
							</p>}
						name="Shelby Wolpa"
						position="Vice President, People Operations @InVision"
						image="/customers/invision/shelby-wolpa-th.jpg"
						cardColor="#FFFFFF"
					/>
				</div>
			</section>

			{/* With ChartHop Section */}
			<section className="with-charthop-section sectionSpacing">
				<div className="container pt-3 pb-5">					
					<div className="row align-items-center pb-3 pb-md-4 pb-lg-5 pt-3 pt-mt-4 pt-lg-5">
						{/* With Charthop COl */}
						<div className="col-md-7 col-lg-6">
							<div className="mr-md-2">
								<h2>Gaining greater insight into a global workforce</h2>
								<p>
									InVision needed a tool that allowed them to visualize relationships between individual employees and larger teams across the company - and that was kept up to date as the organization changed. The problem was that very few solutions featured this kind of functionality.
								</p><p>
									After evaluating a handful of solutions, InVision discovered ChartHop.
								</p><p>
									For InVision, ChartHop wasn’t just a way to visualize relationships between teams, managers, and employees––it <b>became a living document that underpinned the organization’s growth and a critical tool used by employees at all levels on a daily basis</b>.
								</p><p>
									“We're hiring new people and reorganizing often. We can't possibly communicate every single change or it'd be way too noisy. ChartHop has become a great resource for people finding one another, understanding how the organization is designed, and how the organization has changed over time.”
								</p><p>
									<b>ChartHop integrated seamlessly with InVision’s other back-end systems, saving the People Ops team hours of manual data entry and manual reporting.</b> The integrations also allowed the team to start thinking about how to customize ChartHop for their needs right away, rather than worrying about difficult, time-consuming technical overhead.
								</p>
							</div>
						</div><br/>

						{/* Now InVision can COl */}
						<div className="containerNow col-md-5 col-lg-6" >		          
							<div className="flex-centeredColumn contentBlock background-withCharthop">
							<h4 className="text-center"><strong>Now InVision can:</strong></h4>
								<div className="flex-platform svg-info2-withCharthop">
									<div className="svg-info-card-3col2">
										<img src={'/product/org-chart/data-centralization.svg'} alt="Visualize" />
										<p>Empower data-informed decisions</p>
									</div>
									<div className="svg-info-card-3col2">
										<img src={'/product/org-chart/compensation.svg'} alt="Put a face to the name" />
										<p>Access and share accurate reports</p>
									</div>
									<div className="svg-info-card-3col2 people-width">
										<img src={'/customers/customer-stories/prioritize.svg'} alt="Time Saving" />
										<p>Keep org aligned as teams change</p>
									</div>
									<div className="svg-info-card-3col2">
										<img src={'/product/org-chart/light.svg'} alt="Transparency" />
										<p>Derive insights to inform strategy</p>
									</div>
								</div>
							</div>
						</div>
					</div>

					{/*Bullets Section */}
					<div className="sectionSpacing flex-centeredColumn with-charthop-section">
						<div className="contentBlock">
							<h4 className="text-center">Prior to implementing ChartHop, InVision employees typically spent <strong className="p-lightblue">at least an hour every week</strong> searching for the answers to basic questions about their colleagues.</h4>
							<div className="flex-centeredColumn contentBlock">
								<div className="pgc1">
									<div className="pgc2">
										<div className="pgc3">
											<img src={'/product-overview/icons/checkmark_icon.svg'} alt="checkmark" />
											<p className="text-left">Who's that person’s manager?</p>
										</div>
									</div>
									<div className="pgc2">
										<div className="pgc3">
											<img src={'/product-overview/icons/checkmark_icon.svg'} alt="checkmark" />
											<p>Which time zone are they in?</p>
										</div>
									</div>
									<div className="pgc2">
										<div className="pgc3">
											<img src={'/product-overview/icons/checkmark_icon.svg'} alt="checkmark" />
											<p>When was their last promotion?</p>
										</div>
									</div>
									<div className="pgc2">
										<div className="pgc3">
											<img src={'/product-overview/icons/checkmark_icon.svg'} alt="checkmark" />
											<p>When are they fully vested?</p>
										</div>
									</div>
								</div>
							</div>
							<p className="text-center pb-3">ChartHop wasn’t just more convenient and efficient, it also<strong className="p-lightblue"> saved the company the equivalent of $2.5M in lost productivity</strong> across the organization.</p>
						</div>
						<div className="">
							<center><a className="button button-withCharthop" rel="noopener noreferrer" target="_blank" href={PATHS.OVERVIEW}>START SAVING</a></center>
						</div>
					</div>
				</div>
			</section>

			{/* USER TESTIMONY SECTION */}
			<section className="text-left flex-centeredColumn sectionSpacing backgroundGradientContainer-Reverse" id="Testimony">
				<div className="contentBlock d-flex justify-content-between flex-wrap gridContainer"> 
					<UserTestimonyCardNoLogo
						testimony={HtmlParser('<p>"We had cash compensation data in our HRIS and then equity data in our equity management platform. The only way we could bring those two compensation components together was with a manual spreadsheet and resources on my team reporting and auditing on that data.</p><p>That&#39;s how we would run our  compensation planning cycles and share total compensation with our leaders.</p><p>With very little effort, we were able to bring cash and equity together in an automated system for the very first time, articulate the value of that equity, and then be able to take action on the insights."</p>')}	name="Shelby Wolpa"
						position="Vice President, People Operations @ InVision"
						image="/customers/invision/shelby-wolpa-th.jpg"
						cardColor="#FFFFFF"
					/>
				</div>
			</section>		

			{/* TRUSTED */}
			<section className="customer pt-8 pb-5">
				<JoinHappyCustomers title={HtmlParser('Trusted <span class="blue-text">by</span>')}></JoinHappyCustomers>
            </section>			

			{/* LONG FORM */}			
            <section name="request-demo" id="request-demo" className="request-demo pt-3 pb-4 pt-md-8 pb-md-8">
				<DemoFormLong source={"customers-invision-demo-bottom"} centerContent={true} headertext={HtmlParser('<div class="contactTestimonial pr-md-1"><p class=" mb-3 contact-testimonial">"Being able to visualize the org chart by any dimension (department, time, zone, gender, squad) has <strong> empowered</strong> my team to make more strategic people decisions.</p><p class=" mb-3 contact-testimonial"> ChartHop has helped us create a more <strong>transparent</strong> organization and helped employees forge deeper relationships with their coworkers"</p><div class="authorTag"><img src="/customers/invision/shelby-wolpa-th.jpg" class="testimonialAuthor" alt="Shelby Wolpa" /><div><p class="contactAuthor"><strong>Shelby Wolpa</strong> <br>Vice President, People Operations @ InVision</p></div></div>')}/>
			</section>
		</Layout>
	);
};


export default Resources;